(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/construct", "@babel/runtime/helpers/toConsumableArray", "@babel/runtime/helpers/defineProperty", "./index.less", "../address-picker", "../_mixins/picker", "../_util/index", "../_mixins/osProps"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/construct"), require("@babel/runtime/helpers/toConsumableArray"), require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../address-picker"), require("../_mixins/picker"), require("../_util/index"), require("../_mixins/osProps"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.construct, global.toConsumableArray, global.defineProperty, global.index, global.addressPicker, global.picker, global.index, global.osProps);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _construct2, _toConsumableArray2, _defineProperty2, _index, _addressPicker, _picker, _index2, _osProps) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _construct2 = _interopRequireDefault(_construct2);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _addressPicker = _interopRequireDefault(_addressPicker);
  _picker = _interopRequireDefault(_picker);
  _osProps = _interopRequireDefault(_osProps);
  var CURRENT_YEAR = new Date().getFullYear();
  var TYPE_LIST = ['year', 'month', 'date', 'hour', 'minute', 'second'];
  var NATURE_BOUNDARY_MAP = {
    month: {
      natureMin: 1,
      natureMax: 12
    },
    date: {
      natureMin: 1,
      natureMax: 31
    },
    hour: {
      natureMin: 0,
      natureMax: 23
    },
    minute: {
      natureMin: 0,
      natureMax: 59
    },
    second: {
      natureMin: 0,
      natureMax: 59
    }
  };
  var DEFAULT_FORMAT = {
    year: 'YYYY',
    month: 'M',
    date: 'D',
    hour: 'hh',
    minute: 'mm',
    second: 'ss'
  };
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-date-picker",
        attrs: {
          "date-picker-column": _vm.columnCount
        }
      }, [_c('nx-address-picker', {
        attrs: {
          "value": _vm.value,
          "title": _vm.title,
          "describe": _vm.describe,
          "data": _vm.data,
          "selectedIndex": _vm.selectedIndex,
          "swipeTime": _vm.swipeTime,
          "hasMask": _vm.hasMask,
          "lockScroll": _vm.lockScroll,
          "maskClosable": _vm.maskClosable,
          "position": _vm.position,
          "transition": _vm.transition,
          "okText": _vm.okText,
          "cancelText": _vm.cancelText,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "isWebviewFull": _vm.isWebviewFull
        },
        on: {
          "input": _vm.$_onInput,
          "change": _vm._pickerChange,
          "confirm": _vm._pickerConfirm,
          "cancel": _vm._pickerCancel,
          "show": function show($event) {
            return _vm.$emit('show');
          },
          "hide": function hide($event) {
            return _vm.$emit('hide');
          }
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function fn(ref) {
            var pickerData = ref.pickerData;
            return _vm._l(pickerData, function (item) {
              return _c('div', {
                key: item.value,
                staticClass: "time-picker-item",
                attrs: {
                  "type": "date"
                }
              }, [_c('span', [_vm._v(_vm._s(item.text))]), _c('span', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: item.unit,
                  expression: "item.unit"
                }],
                staticClass: "time-unit"
              }, [_vm._v(_vm._s(item.unit))])]);
            });
          }
        }])
      })], 1);
    },
    name: 'nx-date-picker',
    mixins: [_picker.default, _osProps.default],
    components: (0, _defineProperty2.default)({}, _addressPicker.default.name, _addressPicker.default),
    props: {
      min: {
        type: [Date, Array],
        default: function _default() {
          return new Date(2010, 0, 1);
        }
      },
      max: {
        type: [Date, Array],
        default: function _default() {
          return new Date(CURRENT_YEAR, 11, 31);
        }
      },
      startColumn: {
        type: String,
        default: function _default() {
          return 'year';
        }
      },
      columnCount: {
        type: Number,
        default: 3
      },
      format: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      unitList: {
        type: Object,
        default: function _default() {
          return {};
        }
      },
      date: {
        type: [Date, Array],
        default: function _default() {
          return new Date();
        }
      },
      columnOrder: {
        type: Array,
        default: function _default() {
          return ['year', 'month', 'date', 'hour', 'minute', 'second'];
        }
      }
    },
    computed: {
      formatConfig: function formatConfig() {
        var formatConfig = Object.assign({}, DEFAULT_FORMAT);
        (0, _index2.deepAssign)(formatConfig, this.format);
        return formatConfig;
      },
      natureRangeCache: function natureRangeCache() {
        var _this = this;

        var natureRangeCache = {
          hour: [],
          minute: [],
          second: []
        };
        Object.keys(natureRangeCache).forEach(function (key) {
          natureRangeCache[key] = _this._range(key, NATURE_BOUNDARY_MAP[key].natureMin, NATURE_BOUNDARY_MAP[key].natureMax);
        });
        return natureRangeCache;
      },
      startIndex: function startIndex() {
        var startIndex = TYPE_LIST.indexOf(this.startColumn);
        return startIndex < 0 ? 0 : startIndex;
      },
      minArray: function minArray() {
        return this.min instanceof Date ? (0, _index2.dateToArray)(this.min).slice(this.startIndex, this.startIndex + this.columnCount) : this.min;
      },
      maxArray: function maxArray() {
        return this.max instanceof Date ? (0, _index2.dateToArray)(this.max).slice(this.startIndex, this.startIndex + this.columnCount) : this.max;
      },
      columnOrderType: function columnOrderType() {
        var _this2 = this;

        var arr = ['month', 'year'];

        if (arr.length === this.columnOrder.length && arr.every(function (item, index) {
          return Object.is(item, _this2.columnOrder[index]);
        })) {
          return 'MonthYear';
        }

        return '';
      },
      valueArray: function valueArray() {
        if (this.columnOrderType === 'MonthYear') {
          // 只有年月两列
          return this.date instanceof Date ? (0, _index2.dateToArray)(this.date).slice(this.startIndex, this.startIndex + this.columnCount).reverse() : this.date;
        } else {
          return this.date instanceof Date ? (0, _index2.dateToArray)(this.date).slice(this.startIndex, this.startIndex + this.columnCount) : this.date;
        }
      },
      data: function data() {
        var data = [];

        if (this.columnOrderType === 'MonthYear') {
          this._generateDataMonthYear(this.startIndex, 0, data);
        } else {
          this._generateData(this.startIndex, 0, data);
        }

        return data;
      },
      selectedIndex: function selectedIndex() {
        var _this3 = this;

        var selectedIndex = [];
        var data = this.data;
        var index;

        var _loop = function _loop(i) {
          index = (0, _index2.findIndex)(data, function (item) {
            return _this3.valueArray[i] && item.value === _this3.valueArray[i];
          });
          selectedIndex[i] = index !== -1 ? index : 0;
          data = data[selectedIndex[i]] && data[selectedIndex[i]].children;
        };

        for (var i = 0; i < this.columnCount && i < 6 - this.startIndex; i++) {
          _loop(i);
        }

        return selectedIndex;
      }
    },
    methods: {
      /**
       * @function 生成两列数据，第一列是月，第二列是年
       * @param i 列数
       * @param count 列数
       * @param item 每列元素
       * @private
       */
      _generateDataMonthYear: function _generateDataMonthYear(i, count, item) {
        var _this4 = this;

        if (count === 0) {
          // 第1列 月
          var min = 1;
          var max = 12;
          item.push.apply(item, this._range('month', min, max, true, true));
        } else {
          // 第2列 年
          var _min = item.value >= this.minArray[1] ? this.minArray[0] : this.minArray[0] + 1;

          var _max = item.value <= this.maxArray[1] ? this.maxArray[0] : this.maxArray[0] - 1;

          item.children = this._range('year', _min, _max, item.isMin, item.isMax);
        }

        if (count < 1) {
          ;
          (item.children || item).forEach(function (subItem) {
            ;
            (!subItem.children || subItem.isMin || subItem.isMax) && _this4._generateDataMonthYear(i + 1, count + 1, subItem);
          });
        }
      },
      _generateData: function _generateData(i, count, item) {
        var _this5 = this;

        if (count === 0) {
          var min = i === 0 ? this.minArray[0] : Math.max(this.minArray[0], NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMin);
          var max = i === 0 ? this.maxArray[0] : Math.min(this.maxArray[0], NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMax);
          item.push.apply(item, this._range(TYPE_LIST[i], min, max, true, true));
        } else {
          if (i < 3 || item.isMin || item.isMax) {
            var natureMax = i === 2 ? (0, _index2.computeNatureMaxDay)(item.value, item.year) : NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMax;

            var _min2 = item.isMin ? Math.max(this.minArray[count], NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMin) : NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMin;

            var _max2 = item.isMax ? Math.min(this.maxArray[count], natureMax) : natureMax;

            var storageYear = i === 1 && this.startIndex === 0 && this.columnCount >= 3 && item.value;
            item.children = this._range(TYPE_LIST[i], _min2, _max2, item.isMin, item.isMax, storageYear);
          } else {
            item.children = this.natureRangeCache[TYPE_LIST[i]];
          }
        }

        if (count < this.columnCount - 1 && i < 5) {
          ;
          (item.children || item).forEach(function (subItem) {
            ;
            (!subItem.children || subItem.isMin || subItem.isMax) && _this5._generateData(i + 1, count + 1, subItem);
          });
        }
      },
      _pickerChange: function _pickerChange(i, newIndex) {
        this.$emit('change', i, newIndex);
      },
      _pickerConfirm: function _pickerConfirm(selectedVal, selectedIndex, selectedText) {
        var computedSelectedVal = (0, _toConsumableArray2.default)(selectedVal);

        if (this.columnOrderType === 'MonthYear') {
          computedSelectedVal = computedSelectedVal && computedSelectedVal.reverse();
        }

        this.$emit('confirm', this._arrayToDate(computedSelectedVal), selectedVal, selectedText);
      },
      _pickerCancel: function _pickerCancel() {
        this.$emit('cancel');
      },
      _arrayToDate: function _arrayToDate(selectedVal) {
        var args = [];
        var defaultDateArray = (0, _index2.dateToArray)(new Date(0));

        for (var i = 0; i < 6; i++) {
          if (i < this.startIndex) {
            args[i] = defaultDateArray[i];
          } else if (i >= this.startIndex + this.columnCount) {
            args[i] = NATURE_BOUNDARY_MAP[TYPE_LIST[i]].natureMin;
          } else {
            args[i] = selectedVal[i - this.startIndex];
          }
        } // Month need to subtract 1.


        args[1]--;
        return (0, _construct2.default)(Date, args);
      },
      _range: function _range(type, min, max, fatherIsMin, fatherIsMax) {
        var year = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

        if (!this._rangeCache) {
          this._rangeCache = {};
        }

        var k = type + year + min + max + fatherIsMin + fatherIsMax;

        if (this._rangeCache[k]) {
          return this._rangeCache[k];
        }

        var arr = [];
        var format = this.formatConfig[type];

        for (var i = min; i <= max; i++) {
          var text = (0, _index2.formatType)(type, format, i, 'i');
          var unit = this.unitList[type]; // 判断是否是纯数字

          var object = {
            text: text,
            value: i,
            order: this.columnOrder.indexOf(type),
            unit: unit
          };
          if (fatherIsMin && i === min) object.isMin = true;
          if (fatherIsMax && i === max) object.isMax = true;
          if (year) object.year = year;
          arr.push(object);
        }

        this._rangeCache[k] = arr;
        return arr;
      },
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      unitShowBtn: function unitShowBtn(arr) {
        if (arr.length <= 1) {
          return false;
        }

        var firstUnit = arr[0].unit;

        for (var i = 1; i < arr.length; i++) {
          if (arr[i].unit !== firstUnit) {
            return true;
          }
        }

        return false;
      }
    }
  };
  _exports.default = _default2;
});